import Vue from 'vue'
import Router from 'vue-router'
import store from '../store';

Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'IndexPage',
    component: () => import('@/pages/index.vue'),
    meta: {
      showHeader: false,
      showFooter: false,
      requireAuth: false
    }
  },
  {
    path: '/home',
    name: 'HomePage',
    component: () => import('@/pages/home.vue'),
    meta: {
      showHeader: true,
      showFooter: true,
      requireAuth: false
    }
  },
  {
    path: '/search',
    name: 'SearchPage',
    component: () => import('@/pages/search_list.vue'),
    meta: {
      showHeader: true,
      showFooter: true,
      requireAuth: false
    }
  },
  {
    path: '/news',
    name: 'NewsListPage',
    component: () => import('@/pages/news_list.vue'),
    meta: {
      showHeader: true,
      showFooter: true,
      requireAuth: false
    }
  },
  {
    path: '/news/detail',
    name: 'NewsDetailPage',
    component: () => import('@/pages/news_detail.vue'),
    meta: {
      showHeader: true,
      showFooter: true,
      requireAuth: false
    }
  },
  {
    path: '/policy',
    name: 'PolicyListPage',
    component: () => import('@/pages/policy_list.vue'),
    meta: {
      showHeader: true,
      showFooter: true,
      requireAuth: false
    }
  },
  {
    path: '/policy/detail',
    name: 'PolicyDetailPage',
    component: () => import('@/pages/policy_detail.vue'),
    meta: {
      showHeader: true,
      showFooter: true,
      requireAuth: false
    }
  },
  {
    path: '/theory',
    name: 'TheoryListPage',
    component: () => import('@/pages/theory_list.vue'),
    meta: {
      showHeader: true,
      showFooter: true,
      requireAuth: false
    }
  },
  {
    path: '/theory/detail',
    name: 'TheoryDetailPage',
    component: () => import('@/pages/theory_detail.vue'),
    meta: {
      showHeader: true,
      showFooter: true,
      requireAuth: false
    }
  },
  {
    path: '/site',
    name: 'SiteListPage',
    component: () => import('@/pages/site_list.vue'),
    meta: {
      showHeader: true,
      showFooter: true,
      requireAuth: false
    }
  },
  {
    path: '/site/detail',
    name: 'SiteDetailPage',
    component: () => import('@/pages/site_detail.vue'),
    meta: {
      showHeader: true,
      showFooter: true,
      requireAuth: false
    }
  },
  {
    path: '/topic',
    name: 'TopicListPage',
    component: () => import('@/pages/topic_list.vue'),
    meta: {
      showHeader: true,
      showFooter: true,
      requireAuth: false
    }
  },
  {
    path: '/topic/detail',
    name: 'TopicDetailPage',
    component: () => import('@/pages/topic_detail.vue'),
    meta: {
      showHeader: true,
      showFooter: true,
      requireAuth: false
    }
  },
  {
    path: '/teacher_publish',
    name: 'TeacherPublishPage',
    component: () => import('@/pages/teacher_publish.vue'),
    meta: {
      showHeader: true,
      showFooter: true,
      requireAuth: false
    }
  },
  {
    path: '/teacher_publish_edit',
    name: 'TeacherPublishEditPage',
    component: () => import('@/pages/teacher_publish_edit.vue'),
    meta: {
      showHeader: true,
      showFooter: true,
      requireAuth: false
    }
  },
  {
    path: '/teacher_publish_record',
    name: 'TeacherPublishRecordPage',
    component: () => import('@/pages/teacher_publish_record.vue'),
    meta: {
      showHeader: true,
      showFooter: true,
      requireAuth: false
    }
  },
  {
    path: '/teacher_learning_task',
    name: 'TeacherLearningTaskListPage',
    component: () => import('@/pages/teacher_learning_task.vue'),
    meta: {
      showHeader: true,
      showFooter: true,
      requireAuth: false
    }
  },
  {
    path: '/teacher_learning_task_detail',
    name: 'TeacherLearningTaskDetailPage',
    component: () => import('@/pages/teacher_learning_task_detail.vue'),
    meta: {
      showHeader: true,
      showFooter: true,
      requireAuth: false
    }
  },
  {
    path: '/student_learning_task',
    name: 'StudentLearningTaskListPage',
    component: () => import('@/pages/student_learning_task.vue'),
    meta: {
      showHeader: true,
      showFooter: true,
      requireAuth: false
    }
  },
]

const router = new Router({
  mode: 'history',
  base: '/',
  routes: routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

router.beforeEach(async (to, from, next) => {
  document.title = to.meta.title || '思政一体化平台'
  await store.dispatch('checkLogin')
  const isLogin = store.state.account.isLogin
  if (to.path === '/') {
    if (isLogin) {
      next({
        path: '/home',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
      return
    }
  }
  next()
})

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const originalReplace = Router.prototype.replace
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err)
}

export default router
